module.exports = __webpack_public_path__ + "img/img5.b605f518.svg";